// Author-facing photo suggestions for the operator / photographer (PL only — this
// is NOT customer copy, so it deliberately does NOT live in the i18n namespace).
// Surfaced next to each image slot behind the dev/`?brief` gate (useShowPhotoBrief)
// as a collapsible "Sugestia dla fotografa". The full rationale + shot list lives in
// the Outline brief ("Brief zdjęciowy landingu"); this is the in-context short form,
// so a photographer sees the intent exactly where the photo will land.

export interface PhotoBrief {
  /** Short label on the collapsible summary. */
  title: string;
  /** The shooting suggestion: what to capture, how, and what to avoid. */
  note: string;
  /** Sourcing hint shown as a small tag: real photo / stock / 3D render. */
  source: "REAL" | "STOCK" | "RENDER";
}

// NOTE: keep the PL note text free of straight double-quotes (") — use guillemets
// «» or none — so the string literals never terminate early.

export const PHOTO_BRIEFS: Record<string, PhotoBrief> = {
  hero: {
    title: "Zdjęcie główne (hero)",
    source: "REAL",
    note: "Docelowo: właściciel lub dziecko czule trzyma poduszkę-pupila przy policzku lub piersi, ciepły, spokojny uśmiech. Miękkie, naturalne, ciepłe światło (okno, złota godzina), rozmyte domowe tło (kanapa, roślina), bez bałaganu i logotypów. WAŻNE: twarz i wzrok osoby skierowane w LEWO, na nagłówek i przycisk. Kadr poziomy, twarz i poduszka po prawej połowie. Unikać: sztampy stockowej, zimnego światła, produktu «pływającego» w pustce. Zanim będzie fizyczna poduszka, użyj diptyku before→after jako hero.",
  },
  proofAfter: {
    title: "Efekt: gotowa poduszka",
    source: "RENDER",
    note: "Prawa strona porównania «zdjęcie → poduszka». Render z pipeline z prawdziwego zdjęcia pupila (lewa strona = to samo zdjęcie). Gdy będzie fizyczna poduszka, podmień na FOTO gotowej poduszki na neutralnym, ciepłym tle. Zbierz 3–5 różnych pupili: krótkowłosy kot, puszysty pies, czarny pies lub kot (test ciemnej sierści), coś małego.",
  },
  craftMacro: {
    title: "Makro rzemiosła",
    source: "REAL",
    note: "MUSI być prawdziwe zdjęcie (render tu wygląda jak AI). Bardzo blisko: splot bawełny, linia szwu, nitka, zagięcie wypełnienia, krawędź. Światło BOCZNE, miękkie, naturalne, wydobywa fakturę. Produkt ostry, tło rozmyte; pokaż lekką nieidealność (buduje wrażenie ręcznego, nie fabrycznego AI). Wystarczy skrawek docelowej tkaniny na start.",
  },
  craftSteps: {
    title: "Kroki powstawania (1–3)",
    source: "RENDER",
    note: "Trzy etapy: sylwetka → zszycie → wypełnienie. Mogą zostać renderami z pipeline (to dosłownie etapy produkcji). Gdy będzie realna produkcja, podmień na zdjęcia procesu (ręce przy stole krawieckim, maszyna, wypełnianie) w ciepłym, warsztatowym świetle.",
  },
  inScale: {
    title: "Zdjęcie w skali / lifestyle",
    source: "REAL",
    note: "Poduszka trzymana w dwóch dłoniach (pokazuje rozmiar) albo leżąca na kanapie obok zwykłej poduszki dekoracyjnej. Naturalny wystrój domu, ciepłe światło. Cel: wrażenie prawdziwego przedmiotu w domu, nie mockupu. Unikać pustego, studyjnego tła.",
  },
  testimonial: {
    title: "Zdjęcie klienta (opinia)",
    source: "REAL",
    note: "Prawdziwe zdjęcie klienta z pupilem i poduszką, za zgodą (RODO, wizerunek). Naturalne, nie wystudiowane, telefonowe działa. Do zdobycia po pierwszych zamówieniach. Do tego czasu: monogram, bez zmyślonych ocen i gwiazdek.",
  },
  memorial: {
    title: "Wątek pamiątkowy (subtelny)",
    source: "STOCK",
    note: "Spokojne, nostalgiczne zdjęcie pupila lub właściciela, poduszka w tle. Ton cichy, ciepły, światło stonowane. Unikać dosłownej ikonografii żałoby, sugestia zamiast smutku na siłę. Stock i render dopuszczalne.",
  },
  ugc: {
    title: "Galeria zdjęć klientów (UGC)",
    source: "REAL",
    note: "WYŁĄCZNIE prawdziwe zdjęcia klientów, zbierane od pierwszych zamówień (prośba po dostawie, rabat za zgodę). Celowo domowe i telefonowe, autentyczność ponad perfekcję. NIE fabrykować. Sekcja pusta do czasu realnych zdjęć.",
  },
  print3d: {
    title: "Wydruk 3D (obraz 3D)",
    source: "RENDER",
    note: "Jeden mocny kadr wydruku 3D pupila (render lub foto). Pokazuje drugi produkt jako dodatek, poduszka zostaje bohaterem. Ciepłe światło, spójne z resztą strony.",
  },
};
